// extracted by mini-css-extract-plugin
export default {"workspace_wrapper":"page_workspace_wrapper__Oafqf"};